import { Controller } from "@hotwired/stimulus"

// The in-field clear control of the shared HAML search field
// (app/views/shared/_search_input.html.haml), the twin of React's SearchInput
// (#15177). The screen keeps its own search behaviour — a live filter listens
// for `input` on the field, a server search submits its GET form — so this
// controller only:
//   toggle() shows the clear control while the field holds text;
//   clear()  empties the field and re-fires `input`, so whichever screen
//            controller filters on that event re-runs over the full list.
// A server-search clear is a plain link (the partial's clear_url) and needs no
// action here beyond the toggle.
export default class extends Controller {
  static targets = ["input", "clear"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasInputTarget || !this.hasClearTarget) return

    this.clearTarget.classList.toggle("d-none", this.inputTarget.value.length === 0)
  }

  clear(event) {
    event.preventDefault()
    if (!this.hasInputTarget) return

    this.inputTarget.value = ""
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.focus()
  }
}
